/**
 * Phone masks for CF7 fields (site-wide: contact page + project popup).
 *
 * - your-phone     → український формат  +380 (XX) XXX-XX-XX
 * - your-whatsapp  → міжнародний: тільки «+» і цифри (клієнти бувають з-за
 *                    кордону), тому країну не нав'язуємо — легке групування
 *                    по 3 цифри для читабельності.
 *
 * Делегуємо на document, тож поля всередині попапа (рендеряться у footer)
 * теж підхоплюються, і повторний рендер CF7 (AJAX) не ламає маску.
 */
export default function formMasks() {
  const uaFormat = (value) => {
    let d = value.replace(/\D/g, '');
    if (d.startsWith('0')) d = '38' + d;   // 0XX… → 380XX…
    if (d.startsWith('80')) d = '3' + d;   // 80XX… → 380XX…
    if (!d.startsWith('380')) d = '380' + d;
    d = d.slice(0, 12);                     // 380 + 9 цифр
    const r = d.slice(3);
    let out = '+380';
    if (r.length) out += ' (' + r.slice(0, 2);
    if (r.length >= 2) out += ')';
    if (r.length > 2) out += ' ' + r.slice(2, 5);
    if (r.length > 5) out += '-' + r.slice(5, 7);
    if (r.length > 7) out += '-' + r.slice(7, 9);
    return out;
  };

  const intlFormat = (value) => {
    let d = value.replace(/\D/g, '');
    d = d.slice(0, 15);                     // E.164 — максимум 15 цифр
    if (!d) return '';
    return '+' + d.replace(/(\d{3})(?=\d)/g, '$1 ');
  };

  const formatters = {
    'your-phone': uaFormat,
    'your-whatsapp': intlFormat,
  };

  document.addEventListener('input', (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement)) return;
    const fmt = formatters[input.name];
    if (!fmt) return;
    if (input.value.replace(/\D/g, '') === '') { input.value = ''; return; }
    input.value = fmt(input.value);
  });

  // натяк мобільній клавіатурі
  document.querySelectorAll('input[name="your-phone"], input[name="your-whatsapp"]')
    .forEach((i) => i.setAttribute('inputmode', 'tel'));
}
